import { render } from "./AssetBox.vue?vue&type=template&id=2aed8480"
import script from "./AssetBox.vue?vue&type=script&lang=js"
export * from "./AssetBox.vue?vue&type=script&lang=js"
script.render = render

export default script